import 'CountryStateZip.mod';

import 'jquery.validation.lib';

import * as globalFormFunctions from './forms';

Object.assign(window, globalFormFunctions);
